import * as React from "react";
import iconPath from '../assets/icons';

const QrIcon = (props) => {
    const { size, className, ic } = props;

    return (
        <svg width={size ? size : "24"} height={size ? size : "24"} viewBox="0 0 24 24" className={className}>
            <path d={iconPath[ic]} />
        </svg>
    )
}

export default QrIcon;